module.exports = __webpack_public_path__ + "img/number-6.151935ae.svg";